import Vue from 'vue'
import Router from 'vue-router'
//主页
import Index from '@/views/Index'
import IndexCourse from "@/components/IndexCourse";
//筛选后全部课程页面
import CourseList from "@/views/Index/CourseList";
//课程介绍播放页面
import Course from "@/views/Index/Course";
import CourseIntroduce from "@/views/Index/Course/Introduce";
import CourseCatalog from "@/views/Index/Course/Catalog";
import CourseNote from "@/views/Index/Course/Note";
import CourseQuestion from "@/views/Index/Course/Question";
import CourseCollection from "@/views/Index/Course/Collection";
import CourseShare from "@/views/Index/Course/Share";
import CourseRecommend from "@/views/Index/Course/Recommend";
//课程分类
import Class from "@/views/Class";
import ClassCourse from "@/views/Class/Course";
import CourseClass from "@/views/Class/Course/CourseClass";
//更多页
import CourseMore from "@/views/Class/CourseMore";
//资源检索
import Resource from "@/views/Resource";
//个人中心
import Personal from "@/views/Personal";
import PersonalGroup from "@/components/PersonalGroup";
import StudyRecord from "@/views/Personal/StudyRecord";
import MyCourse from "@/views/Personal/MyCourse";
import MyCollection from "@/views/Personal/MyCollection";
import MyNotes from "@/views/Personal/MyNotes";
import MyQuestion from "@/views/Personal/MyQuestion";
import MyContacts from "@/views/Personal/MyContacts";

//分享页面
//import ShareVideo from "@/components/ShareVideo";
Vue.use(Router)

export default new Router({
	mode: 'hash',
	base: '/ydrj/',
	routes: [{
			path: '/Index',
			name: 'Index',
			component: Index,
			children: [{
				path: '/IndexCourse',
				component: IndexCourse
			}, {
				path: '/Index/CourseList',
				name: '/Index/CourseList',
				component: CourseList
			}, {
				path: '/Index/Course',
				name: '/Index/Course',
				component: Course,
				children: [{
					path: '/Index/Course/Introduce',
					name: '/Index/Course/Introduce',
					component: CourseIntroduce
				}, {
					path: '/Index/Course/Catalog',
					name: '/Index/Course/Catalog',
					component: CourseCatalog
				}, {
					path: '/Index/Course/Note',
					name: '/Index/Course/Note',
					component: CourseNote
				}, {
					path: '/Index/Course/Question',
					name: '/Index/Course/Question',
					component: CourseQuestion
				}, {
					path: '/Index/Course/Collection',
					name: '/Index/Course/Collection',
					component: CourseCollection
				}, {
					path: '/Index/Course/Share',
					name: '/Index/Course/Share',
					component: CourseShare
				}, {
					path: '/Index/Course/Recommend',
					name: '/Index/Course/Recommend',
					component: CourseRecommend
				}]
			}]
		},
		{
			path: '/Class',
			name: 'Class',
			component: Class,
			children: [{
				path: '/Class/Course',
				name: '/Class/Course',
				component: ClassCourse,
				children: [{
					path: '/Class/Course/CourseClass',
					component: CourseClass
				}]
			}]
		},
		{
			path: '/Class/CourseMore',
			name: 'CourseMore',
			component: CourseMore
		},
		/* 
		        {
		            path: '/ShareVideo',
		            name: 'ShareVideo',
		            component: ShareVideo
		        }, */
		{
			path: '/Resource',
			name: 'Resource',
			component: Resource
		},
		{
			path: '/ShhgxyLogin',
			name: 'ShhgxyLogin',
			component: () => import("../views/ShhgxyLogin.vue")
		},
		{
			path: '/Personal/StudyRecord',
			name: 'StudyRecord',
			component: StudyRecord
		},
		{
			path: '/Personal/PersonalGroup',
			name: 'PersonalGroup',
			component: PersonalGroup
		},  
		{
			path: '/Personal/MyCourse',
			name: 'MyCourse',
			component: MyCourse
		}, 
		{
			path: '/Personal/MyCollection',
			name: 'MyCollection',
			component: MyCollection
		}, 
		{
			path: '/Personal/MyNotes',
			name: 'MyNotes',
			component: MyNotes
		}, 
		{
			path: '/Personal/MyQuestion',
			name: 'MyQuestion',
			component: MyQuestion
		}, 
		{
			path: '/Personal/MyContacts',
			name: 'MyContacts',
			component: MyContacts
		},
		{
			path: '/Personal',
			name: 'Personal',
			component: Personal,
		},
		{
			path: '*',
			name: 'notfount',
			component: Index
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js